<script lang="ts" setup>
defineProps<{
  title?: string;
  balanced?: boolean;
}>();
</script>

<template>
  <div class="contentProseTable">
    <p v-if="title" class="contentProseTable__title">
      {{ title }}
    </p>
    <div class="contentProseTable__scroll">
      <table class="contentProseTable__data" :class="{ contentProseTable__data_balanced: balanced }" v-bind="$attrs">
        <slot />
      </table>
    </div>
  </div>
</template>

<style lang="scss">
.contentProseTable {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  margin-bottom: 40px;

  @include mq('md') {
    font-size: 14px;
    line-height: 20px;
  }

  @include mq('sm') {
    font-size: 13px;
    line-height: 18px;
  }

  @include mq('xs') {
    font-size: 12px;
    line-height: 16px;
  }

  &__title {
    border-top: 1px solid black;
    height: 52px;
    line-height: 52px !important;
    margin-bottom: 0 !important;
  }

  &__scroll {
    overflow: auto;
  }

  &__data {
    min-width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    border-style: hidden;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    table-layout: fixed;
    text-align: center;

    @include mq('md') {
      min-width: 500px;
    }

    &_balanced {
      width: 100%;
    }

    &:not(&_balanced) {
      th,
      td {
        padding: 8px;
      }
    }
  }

  th,
  td {
    border: 1px solid black;
    height: 52px;
    position: relative;
    padding: 8px 2px;

    &[rowspan='2'] {
      height: 104px;
    }
  }

  .p-0 {
    padding: 0;
  }

  & .left {
    text-align: left;
    padding-left: 0;
  }

  .width-1-to-2 {
    width: calc(100% / 2);
  }

  .width-2-to-3 {
    width: calc(100% * 2 / 3);
  }

  .icon-left {
    position: absolute;
    left: 25%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .icon-right {
    position: absolute;
    right: 25%;
    top: 50%;
    transform: translate(50%, -50%);
  }

  .cell-beige {
    background-color: #e4e4e4;
  }

  .cell-gray {
    background-color: #d9dadc;
  }

  .cell-blue {
    background-color: #6b8ad9;
    color: #fff;
  }

  .cell-lightblue {
    background-color: #8eabd9;
    color: #fff;
  }

  .cell-violet {
    background-color: #2b1c45;
    color: #fff;
  }

  .cell-darkgray {
    background-color: #444444;
    color: #fff;
  }

  .cell-yellow {
    background-color: #f0b042;
    color: #fff;
  }

  .cell-orange {
    background-color: #d37b23;
    color: #fff;
  }

  .cell-goldenrod {
    background-color: #ba8623;
    color: #fff;
  }

  .cell-peru {
    background-color: peru;
    color: #fff;
  }

  .cell-pink {
    background-color: #e46260;
    color: #fff;
  }

  .cell-indianred {
    background-color: #d18391;
    color: #fff;
  }

  .cell-green {
    background-color: #657e2d;
    color: #fff;
  }

  .cell-purple {
    background-color: #761656;
    color: #fff;
  }
  .cell-red-ping {
    background-color: #c63527;
    color: #fff;
  }

  .cell-raspberry {
    background-color: #890c58;
    color: #fff;
  }

  .cell-goldenrod-yellow {
    background: linear-gradient(to right bottom, #ba8623 0%, #ba8623 49%, #f0b042 51%, #f0b042 100%);
    color: #fff;
  }

  .cell-yellow-violet {
    background: linear-gradient(to right bottom, #f0b042 0%, #f0b042 49%, #2b1c45 51%, #2b1c45 100%);
    color: #fff;
  }

  .cell-goldenrod-violet {
    background: linear-gradient(to right bottom, #ba8623 0%, #ba8623 49%, #2b1c45 51%, #2b1c45 100%);
    color: #fff;
  }

  .cell-purple-pink {
    background: linear-gradient(to right bottom, #761656 0%, #761656 49%, #e46260 51%, #e46260 100%);
    color: #fff;
  }

  .cell-pink-purple {
    background: linear-gradient(to right bottom, #e46260 0%, #e46260 49%, #761656 51%, #761656 100%);
    color: #fff;
  }

  .cell-purple-indianred {
    background: linear-gradient(to right bottom, #761656 0%, #761656 49%, #d18391 51%, #d18391 100%);
    color: #fff;
  }

  .cell-indianred-purple {
    background: linear-gradient(to right bottom, #d18391 0%, #d18391 49%, #761656 51%, #761656 100%);
    color: #fff;
  }

  .cell-lightblue-indianred {
    background: linear-gradient(to right bottom, #8eabd9 0%, #8eabd9 49%, #d18391 51%, #d18391 100%);
    color: #fff;
  }

  .cell-purple-green {
    background: linear-gradient(to right bottom, #761656 0%, #761656 49%, #657e2d 51%, #657e2d 100%);
    color: #fff;
  }

  .cell-green-purple {
    background: linear-gradient(to right bottom, #657e2d 0%, #657e2d 49%, #761656 51%, #761656 100%);
    color: #fff;
  }
}
</style>
